import Affix from 'antd/lib/affix'

import 'antd/lib/affix/style'

export * from 'antd/lib/affix'

export default Affix
